import { render, staticRenderFns } from "./Radiobox.vue?vue&type=template&id=f1b783ac&"
import script from "./Radiobox.vue?vue&type=script&lang=js&"
export * from "./Radiobox.vue?vue&type=script&lang=js&"
import style0 from "./Radiobox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports